module.exports = __webpack_public_path__ + "media/images/favicon/ms-icon-150x150-50c954bcabbdfd195f012f0aa7a6bada.png";